export default __webpack_public_path__ + "static/media/hero-audubon.cc3eb528.webp";